<div class="base-modal">
  <span class="base-modal__close-button" (click)="closeModal()">
    <i class="material-icons"> close </i>
  </span>
  <div class="base-modal__header">
    <h2 class="base-modal__title">Instagram connection</h2>
  </div>
  <!-- ----------------------- Select connection type ------------------------ -->
  <ng-container *ngIf="curentState === states.Start">
    <div class="base-modal__footer">
      <button
        class="button button--flat"
        (click)="changeState(states.NewOfficial)"
      >
        Use official connection
      </button>

      <button
        class="button button--flat"
        (click)="changeState(states.NewUnofficial)"
      >
        Use unofficial connection
      </button>
    </div>
  </ng-container>
  <!-- -------------------- New official connection form --------------------- -->
  <ng-container *ngIf="curentState === states.NewOfficial">
    <form [formGroup]="instagramOfficialForm">
      <div class="base-modal__body" *ngIf="facebookAuthStatus === 'connected'">
        <div class="brn-form-field">
          <brn-select
            formControlName="page"
            [options]="facebookPages"
            [suggest]="true"
            [theme]="'grey'"
            [optionLabel]="'name'"
            [placeholder]="'Select page...'"
          >
          </brn-select>
        </div>
        <div class="brn-form-field" *ngIf="advancedConnectionsPermission">
          <brn-form-checkbox formControlName="unofficial_fallback"
            >Use unofficial fallback</brn-form-checkbox
          >
        </div>
        <ng-container *ngIf="unofficialFallback">
          <div class="brn-form-field">
            <input
              type="text"
              formControlName="username"
              placeholder="Username"
            />
          </div>
          <div class="brn-form-field">
            <input
              type="text"
              formControlName="password"
              placeholder="Password"
            />
          </div>
          <div class="brn-form-field">
            <input
              type="text"
              formControlName="proxy"
              placeholder="http://your_proxy"
            />
          </div>
        </ng-container>
      </div>

      <div class="base-modal__footer">
        <button
          *ngIf="
            !facebookAuthStatus ||
            facebookAuthStatus === 'not_connected' ||
            facebookAuthStatus === 'pending'
          "
          class="button button--flat"
          (click)="getFacebookIgPages()"
        >
          Connect facebook page
          <i
            *ngIf="facebookAuthStatus === 'pending'"
            class="material-icons button__loader"
          >
            rotate_right
          </i>
        </button>

        <button
          *ngIf="facebookAuthStatus === 'connected'"
          class="button button--flat"
          (click)="createOfficialConnection()"
          [ngClass]="{ 'button--disabled': !validOfficialForm }"
        >
          Create connection
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
      </div>
    </form>
  </ng-container>
  <!-- -------------------- Edit official connection form -------------------- -->
  <ng-container *ngIf="curentState === states.EditOfficial">
    <form [formGroup]="instagramOfficialForm">
      <div class="base-modal__body">
        <div class="brn-form-field">
          <brn-select
            *ngIf="facebookAuthStatus === 'connected'"
            formControlName="page"
            [options]="facebookPages"
            [suggest]="true"
            [theme]="'grey'"
            [optionLabel]="'name'"
            [placeholder]="'Select page...'"
          >
          </brn-select>
        </div>
        <div
          class="brn-form-field brn-form-field--pointer"
          *ngIf="
            !facebookAuthStatus ||
            facebookAuthStatus === 'not_connected' ||
            facebookAuthStatus === 'pending'
          "
        >
          <input
            (click)="getFacebookIgPages()"
            type="text"
            readonly
            placeholder="Select page..."
            [value]="pageName"
          />
          <i
            (click)="getFacebookIgPages()"
            class="material-icons reset-icon"
            [ngClass]="{
              'reset-icon--animated': facebookAuthStatus === 'pending'
            }"
          >
            rotate_right
          </i>
        </div>
        <div class="brn-form-field" *ngIf="advancedConnectionsPermission">
          <brn-form-checkbox formControlName="unofficial_fallback"
            >Use unofficial fallback</brn-form-checkbox
          >
        </div>
        <ng-container *ngIf="unofficialFallback">
          <div class="brn-form-field">
            <input
              type="text"
              formControlName="username"
              placeholder="Username"
            />
          </div>
          <div class="brn-form-field">
            <input
              type="password"
              formControlName="password"
              placeholder="Password"
            />
          </div>
          <div class="brn-form-field">
            <input
              type="text"
              formControlName="proxy"
              placeholder="http://your_proxy"
            />
          </div>
        </ng-container>
      </div>

      <div class="base-modal__footer">
        <button
          class="button button--flat"
          (click)="updateOfficialConnection()"
          [ngClass]="{ 'button--disabled': !validOfficialForm }"
        >
          Save changes
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
        <button
          class="button button--flat button--danger"
          (click)="removeConnection()"
        >
          Remove connection
        </button>
      </div>
    </form>
  </ng-container>
  <!-- ------------------- New unofficial connection form -------------------- -->
  <ng-container *ngIf="curentState === states.NewUnofficial">
    <form [formGroup]="instagramUnofficialForm">
      <div class="base-modal__body">
        <div class="brn-form-field">
          <input
            type="text"
            formControlName="username"
            placeholder="Username"
          />
        </div>
        <div class="brn-form-field">
          <input
            type="password"
            formControlName="password"
            placeholder="Password"
          />
        </div>
        <div class="brn-form-field">
          <span class="feed-interval-postfix"> ms </span>
          <input
            type="text"
            digitOnly
            inputmode="numeric"
            [min]="0"
            formControlName="feed_check_interval"
            placeholder="Feed check interval"
            title="Feed check interval"
          />
        </div>
        <div class="brn-form-field">
          <brn-select
            formControlName="realtime_mode"
            [options]="['web', 'android']"
            [theme]="'grey'"
            [placeholder]="'Realtime mode'"
          >
          </brn-select>
        </div>
        <div class="brn-form-field">
          <input
            type="text"
            formControlName="proxy"
            placeholder="http://your_proxy"
          />
        </div>
        <div class="brn-form-field">
          <brn-form-checkbox formControlName="process_media"
            >Process Media</brn-form-checkbox
          >
        </div>
      </div>

      <div class="base-modal__footer">
        <button
          class="button button--flat"
          (click)="createUnofficialConnection()"
          [ngClass]="{ 'button--disabled': !validUnofficialForm }"
        >
          Create connection
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
      </div>
    </form>
  </ng-container>
  <!-- ------------------- Edit unofficial connection form ------------------- -->
  <ng-container *ngIf="curentState === states.EditUnofficial">
    <form [formGroup]="instagramUnofficialForm">
      <div class="base-modal__body">
        <div class="brn-form-field">
          <input
            type="text"
            formControlName="username"
            placeholder="Username"
          />
        </div>
        <div class="brn-form-field">
          <input
            type="password"
            formControlName="password"
            placeholder="Password (if it changed)"
          />
        </div>
        <div class="brn-form-field">
          <span class="feed-interval-postfix"> ms </span>
          <input
            type="text"
            digitOnly
            inputmode="numeric"
            [min]="0"
            formControlName="feed_check_interval"
            placeholder="Feed check interval"
            title="Feed check interval"
          />
        </div>
        <div class="brn-form-field">
          <brn-select
            formControlName="realtime_mode"
            [options]="['web', 'android']"
            [theme]="'grey'"
            [placeholder]="'Realtime mode'"
          >
          </brn-select>
        </div>
        <div class="brn-form-field">
          <input
            type="text"
            formControlName="proxy"
            placeholder="http://your_proxy"
          />
        </div>
        <div class="brn-form-field">
          <brn-form-checkbox formControlName="process_media"
            >Process Media</brn-form-checkbox
          >
        </div>
      </div>

      <div class="base-modal__footer">
        <button
          class="button button--flat"
          (click)="updateUnofficialConnection()"
          [ngClass]="{ 'button--disabled': !validUnofficialForm }"
        >
          Save changes
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
        <button
          class="button button--flat button--danger"
          (click)="removeConnection()"
        >
          Remove connection
        </button>
      </div>
    </form>
  </ng-container>
</div>
